import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const DirectShelfButton = styled(ButtonMui)`
  height: 3.5em;
  width: 16rem;
`

export const PageBreak = styled.div`
  @media all {
    display: none;
  }
  @media print {
    html,
    body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
  }
  @media print {
    margin-top: 1rem;
    display: block;
    page-break-before: always;
  }
  @page {
    size: auto;
    margin: 30mm;
  }
`
